module.exports = __webpack_public_path__ + "static/media/exo-latin-500italic.712ade42.woff";